<!--
    添加标签
    jay 2020-01-02
 -->
<template>
  <div>
    <Modal
      :value="addTagTelPop"
      :title="$t('recharge.addFavoriteNumber')"
      class-name="vertical-center-modal"
      width="490"
      :mask-closable="false"
      @on-visible-change="modalFun"
      @on-cancel="closePop"
    >
      <div slot="header" class="chooseTag-title">
        <a v-if="tagItemPop" @click="tagItemPop = false">{{
          $t("common.back")
        }}</a>
        <span v-else>{{ $t("recharge.addFavoriteNumber") }}</span>
      </div>
      <div class="modal-container">
        <div class="tag-list" v-if="tagItemPop">
          <h3>
            <span>{{ $t("recharge.labelManagement") }}</span>
          </h3>
          <div class="tag-item" v-for="(tag, index) in tagList" :key="index">
            <span>{{ tag.tag_name }}</span>
            <p>
              <a @click="delTag(index)">{{ $t("common.delete") }}</a>
              <a @click="editTag(index)">{{ $t("common.edit") }}</a>
            </p>
          </div>
        </div>
        <template v-else>
          <div class="add-tag">
            <h3>
              <span>{{ $t("recharge.addNewLabel") }}</span>
              <a @click="addTagSubmit">
                {{ $t("common.add") }}
              </a>
            </h3>
            <Input
              class="tel-input"
              v-model="currgetTag"
              :placeholder="$t('recharge.enterLabelName')"
            />
          </div>
          <div class="my-tag">
            <h3>
              <span>{{ $t("recharge.myLabel") }}</span>
              <a
                :class="{ 'text-gray': tagList.length == 0 }"
                @click="tagTeamShow"
              >
                {{ $t("recharge.labelManagement") }}
              </a>
            </h3>
            <div class="tag-wrapper">
              <span
                :class="{ active: checkTagIndex == index }"
                v-for="(tag, index) in tagList"
                :key="index"
                @click="checkTagEvent(index)"
              >
                {{ tag.tag_name }}
              </span>
            </div>
          </div>
        </template>
      </div>
      <div slot="footer" class="footer" align="center">
        <Button
          type="primary"
          :class="{ 'text-gray': tagList.length == 0 }"
          :loading="submitLoading"
          @click="addMobileFun"
          v-if="!tagItemPop"
        >
          {{ $t("common.save") }}
        </Button>
        <p v-if="!tagItemPop">{{ $t("recharge.clickNumberToLabel") }}</p>
      </div>
    </Modal>
    <!-- 编辑标签 -->
    <Modal
      v-model="editTagPop"
      :title="$t('common.delete')"
      class-name="vertical-center-modal"
      @on-cancel="cancelEvent"
      width="490"
      :mask-closable="false"
    >
      <div class="modal-container">
        <Input
          class="tel-input"
          v-model="currgetTag"
          :placeholder="$t('recharge.enterLabelName')"
        />
      </div>
      <div slot="footer" class="footer" align="center">
        <Button type="primary" :loading="editTagFlag" @click="editTagSubmit">
          {{ $t("common.save") }}
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    addTagTelPop: {
      type: Boolean,
      default: false
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      tagItemPop: false, //管理标签显示与隐藏
      currgetTagIndex: -1, //当前选中的标签的下标
      currgetTag: "", //当前选中的标签
      checkTagIndex: 0, //选择标签下标
      editTagPop: false, //编辑标签弹窗
      editTagFlag: false
      // addTagLoading: false, //添加标签loading
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    closePop() {
      let vm = this;
      vm.$emit("update:addTagTelPop", false);
      vm.checkTagIndex = 0;
    },
    modalFun(data) {
      //添加标签弹窗发生变化
      if (!data) {
        this.tagItemPop = false;
      }
    },
    checkTagEvent(index, flag) {
      //选择标签
      let vm = this;
      if (vm.checkTagIndex == index) {
        return;
      }
      vm.checkTagIndex = index;
      if (flag) {
        //如果是导入号码点击的标签，则不进行编辑
        return;
      }
    },
    tagTeamShow() {
      //标签管理
      let vm = this;
      if (vm.tagList.length == 0) {
        return false;
      }
      vm.tagItemPop = true;
    },
    delTag(index) {
      //删除标签
      let vm = this;
      if (vm.delTagFlag) {
        return;
      }
      let flag = 0;
      if (vm.checkTagIndex == index) {
        flag = 1;
      }
      if (vm.checkTagIndex < index) {
        flag = 2;
      }
      if (vm.checkTagIndex > index) {
        flag = 3;
      }
      let params = {};
      params.tag = vm.tagList[index].id;
      vm.delTagFlag = true;
      vm.$Spin.show();
      vm.$post("/app/user/delTags", params, { alert: true }).then(res => {
        vm.$Spin.hide();
        if (res.code == 0) {
          vm.$Message.success({
            content: res.msg,
            onClose: function() {
              if (flag == 1) {
                vm._getTagList(2);
              } else if (flag == 2) {
                vm._getTagList(4);
              } else if (flag == 3) {
                vm._getTagList(3);
              }
            }
          });
        } else {
          vm.$Message.error({
            content: res.msg,
            onClose: function() {
              vm.delTagFlag = false;
            }
          });
        }
      });
    },
    editTag(index) {
      //编辑标签
      let vm = this;
      vm.editTagPop = true;
      vm.currgetTagIndex = index;
      vm.currgetTag = vm.tagList[vm.currgetTagIndex].tag_name;
    },

    addMobileFun() {
      //添加号码
      let vm = this;
      let data = {};
      data.checkTagIndex = vm.checkTagIndex;
      vm.$emit("addMobile", data);
    },
    editTagSubmit() {
      //编辑标签提交
      let vm = this;
      if (vm.editTagFlag) {
        return;
      }
      if (vm.currgetTag == "") {
        vm.$Message.error(vm.$t("recharge.enterLabelName"));
        return false;
      }

      let reg = /^[\da-z\u4e00-\u9fa5]{2,4}$/i;
      if (!reg.test(vm.currgetTag)) {
        vm.$Message.error(vm.$t("recharge.enter2-4letterOrChinese"));
        return false;
      }
      let params = {};
      params.tag_id = vm.tagList[vm.currgetTagIndex].id;
      params.tag_name = vm.currgetTag;
      vm.editTagFlag = true;
      vm.$post("/app/user/userMobileTagsEdit", params, { alert: true }).then(
        res => {
          vm.editTagFlag = false;
          if (res.code == 0) {
            vm.$Message.success({
              content: res.msg,
              onClose: function() {
                vm.tagList[vm.currgetTagIndex].tag_name = vm.currgetTag;
                vm.currgetTag = "";
                vm.currgetTagIndex = null;
                vm.editTagPop = false;
              }
            });
          } else {
            vm.$Message.error({
              content: res.msg,
              onClose: function() {}
            });
          }
        }
      );
    },
    cancelEvent() {
      //编辑/添加弹窗点击关闭
      let vm = this;
      vm.currgetTag = "";
      vm.currgetTagIndex = null;
    },
    addTagSubmit() {
      //添加标签
      let vm = this;
      if (vm.addTagFlag) {
        return;
      }
      if (vm.currgetTag == "") {
        vm.$Message.error(vm.$t("recharge.enterLabelName"));
        return false;
      }

      let reg = /^[\da-z\u4e00-\u9fa5]{2,4}$/i;
      if (!reg.test(vm.currgetTag)) {
        vm.$Message.error(vm.$t("recharge.enter2-4letterOrChinese"));
        return false;
      }
      let params = {};
      params.tag_name = vm.currgetTag;
      vm.addTagFlag = true;
      vm.$Spin.show();
      vm.$post("/app/user/userMobileTagsAdd", params, { alert: true }).then(
        res => {
          vm.$Spin.hide();
          if (res.code == 0) {
            vm.$Message.success({
              content: res.msg,
              onClose: function() {
                vm._getTagList(1);
                vm.currgetTag = "";
                vm.currgetTagIndex = null;
              }
            });
          } else {
            vm.$Message.error({
              content: res.msg,
              onClose: function() {
                vm.currgetTag = "";
                vm.currgetTagIndex = null;
                vm.addTagFlag = false;
              }
            });
          }
        }
      );
    },
    _getTagList(flag) {
      //获取标签列表
      let vm = this;
      vm.$post("/app/user/userMobileTags", {}).then(res => {
        // vm.tagList = res.list;
        vm.$emit("changeTagList", res.list);

        if (vm.delTagFlag) {
          vm.delTagFlag = false;
        }
        if (vm.addTagFlag) {
          vm.addTagFlag = false;
        }
        if (flag == 1) {
          if (res.list.length) {
            vm.checkTagIndex = res.list.length - 1;
          } else {
            if (vm.tagItemPop) {
              vm.tagItemPop = false;
            }
          }
        } else if (flag == 2) {
          if (res.list.length) {
            vm.checkTagIndex = 0;
          } else {
            if (vm.tagItemPop) {
              vm.tagItemPop = false;
            }
          }
        } else if (flag == 3) {
          if (res.list.length) {
            vm.checkTagIndex = vm.checkTagIndex - 1;
          } else {
            if (vm.tagItemPop) {
              vm.tagItemPop = false;
            }
          }
        }
      });
    }
  },
  components: {},
  watch: {},
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.modal-container {
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 24px;
    }
  }
  p {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 28px;
    margin-bottom: 20px;
  }
}

.footer {
  position: relative;
  p {
    font-size: 12px;
    color: #666;
    padding-top: 10px;
    text-align: center;
  }
  .file {
    position: absolute;
    width: 330px;
    height: 45px;
    font-size: 20px;
    opacity: 0;
  }
  .tips {
    width: 330px;
    text-align: center;
    font-size: 12px;
    color: #666;
    padding-top: 10px;
  }
  .skip {
    display: block;
    margin-top: 24px;
    color: #2042ab;
    font-size: 16px;
    line-height: 22px;
    text-decoration: underline;
  }
  /deep/.ivu-btn-primary.text-gray {
    background: #b6b6b6;
    color: #ddd;
  }
  /deep/.ivu-btn-primary.text-gray:focus {
    box-shadow: 0 0 0 2px #ddd;
  }
}
.tag-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
  /deep/.ivu-icon-ios-add-circle-outline {
    margin-right: 8px;
    color: #2042ab;
    cursor: pointer;
  }
  span {
    font-size: 14px;
    color: #4a4a4a;
    display: inline-block;
    padding: 0 15px;
    line-height: 28px;
    background: rgba(239, 242, 245, 1);
    border-radius: 14px;
    margin-right: 8px;
    cursor: pointer;
    &.active {
      background: #2042ab;
      color: #fff;
    }
  }
}

.tel-input {
  /deep/.ivu-input {
    padding: 0;
    height: 40px;
    font-size: 16px;
    border-radius: 0;
    border-width: 0 0 1px 0;
    &:focus {
      box-shadow: none;
    }
  }
  &.onlyread {
    /deep/.ivu-input-prefix i {
      line-height: 40px;
      color: #2042ab;
    }
    /deep/.ivu-input {
      padding-left: 30px;
      color: #2042ab;
      cursor: pointer;
    }
  }
}
.add-tag,
.my-tag {
  margin-bottom: 10px;
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 16px;
    }
  }
}
.chooseTag-title {
  span {
    font-size: 18px;
  }
  a {
    font-size: 14px;
  }
}
.tag-list {
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 16px;
    }
  }
  .tag-item {
    height: 50px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    p {
      margin-bottom: 0;
    }
    a {
      margin-left: 15px;
    }
  }
}
</style>
